import { z } from 'zod';
import { BaseFlowBlockSchema } from '../block.js';
import { FlowBlockType } from '../type.js';
export const FlowTestLifecycleBlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.TestLifecycle),
    config: z.object({
        preExecuteThrow: z.boolean().optional(),
        executeThrow: z.boolean().optional(),
        postExecuteThrow: z.boolean().optional(),
        callbackHandlerThrow: z.boolean().optional(),
        gotSignal: z.boolean().optional(),
        callbackEndsBlock: z.boolean().optional(),
        callbackEndsBlockWithError: z.boolean().optional(),
    }),
});
//# sourceMappingURL=config.js.map